import { createFileRoute, notFound } from "@tanstack/react-router";

import { resolveGatewayAdminAccess } from "@/common/gateway-session";
import { AdminLayout } from "@/features/admin/AdminLayout";
import { stewardFontLinks } from "@/landing/styles/steward-fonts";
import stewardThemeCss from "@/landing/styles/steward-theme.css?url";

export const Route = createFileRoute("/_authenticated/(admin)/admin")({
  head: () => ({
    links: [{ rel: "stylesheet", href: stewardThemeCss }, ...stewardFontLinks],
  }),
  beforeLoad: async ({ preload }) => {
    if (preload) return;

    // The admin flag comes from /oauth/userinfo.
    const access = await resolveGatewayAdminAccess();
    if (access === "admin") return;
    // Authenticated but userinfo is unavailable (retries exhausted): don't
    // lock a real admin out with a 404 — surface a retryable error instead.
    if (access === "unavailable") {
      throw new Error(
        "Could not verify admin access right now. Please reload to try again.",
      );
    }
    // not-admin or unauthenticated → hide the route.
    throw notFound();
  },
  component: AdminLayout,
});
